import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AccountService } from '@app/_services';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
    constructor(
        private router: Router,
        private accountService: AccountService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const user = this.accountService.userValue;

        // ✅ User must be logged in
        if (!user) {
            this.router.navigate(['/account/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }

        // ✅ Sales role should not see the dashboard/home page
        if (route.routeConfig?.path === '' && this.accountService.isSales()) {
            this.router.navigate(['/attendance']);
            return false;
        }

        // ✅ Role-based route access (if roles are defined in the route)
        const roles = route.data['roles'];
        if (roles && !roles.includes(user.roleId)) {
            this.router.navigate(['/']);
            return false;
        }

        // ✅ Page-based access using hasPermission
        const allowAllUsers = route.data?.['allowAllUsers'];
        if (allowAllUsers || user.isSuperAdmin) {
            return true;
        }

        // Some routes accept any one of several permission pages (e.g. My Salary
        // should be reachable by anyone with Attendance access, not just Payroll).
        const permissionPages: string[] = route.data?.['permissionPages'];
        if (permissionPages?.length) {
            const allowed = permissionPages.some(p => this.accountService.hasPermission(p, 'canRead'));
            if (!allowed) {
                this.router.navigate(['/']);
                return false;
            }
            return true;
        }

        const page = route.routeConfig?.path;
        if (page && !this.accountService.hasPermission(page, 'canRead')) {
            this.router.navigate(['/']);
            return false;
        }

        return true;
    }
}